import api from './api';

const referenceLabService = {
  getReferenceLabs: async (params = {}) => {
    const res = await api.get('/reference-labs', { params });
    return res.data;
  },

  getReferenceLabById: async (id) => {
    const res = await api.get(`/reference-labs/${id}`);
    return res.data;
  },

  createReferenceLab: async (data) => {
    const res = await api.post('/reference-labs', data);
    return res.data;
  },

  updateReferenceLab: async (id, data) => {
    const res = await api.put(`/reference-labs/${id}`, data);
    return res.data;
  },

  updateStatus: async (id, isActive) => {
    const res = await api.patch(`/reference-labs/${id}/status`, isActive, {
      headers: { 'Content-Type': 'application/json' }
    });
    return res.data;
  },

  getMappings: async (params = {}) => {
    const res = await api.get('/reference-labs/mappings', { params });
    return res.data;
  },

  saveMapping: async (data) => {
    const res = await api.post('/reference-labs/mappings', data);
    return res.data;
  },

  deleteMapping: async (mappingId) => {
    const res = await api.delete(`/reference-labs/mappings/${mappingId}`);
    return res.data;
  }
};

export default referenceLabService;
